import { Client } from '@/pages/user/api';
import { AccountModule } from '@/store/modules/account';
import { downloadByAuthUrl } from '@/utils/file.util';
import * as Cache from '@/utils/cache.util';

const apiPrefix = 'portal';

export type SkuCategoryType = 'SAMPLE' | 'JD_ECO';

export const SKU_CATEGORY_TYPE = {
  SAMPLE: 'SAMPLE' as SkuCategoryType,
  JD_ECO: 'JD_ECO' as SkuCategoryType,
};

export const SKU_CATEGORY_TYPE_OPTIONS = [
  { label: '打样商品分类', value: SKU_CATEGORY_TYPE.SAMPLE },
  { label: '京东生态店商品分类', value: SKU_CATEGORY_TYPE.JD_ECO },
];

export type SkuCategoryTreeItem = {
  id: string | number;
  code: string;
  parentCode?: string;
  categoryType?: SkuCategoryType;
  name: string;
  displayTitle?: string;
  displayDescription?: string;
  relatedCategoryText?: string;
  backgroundImageUrl?: string;
  backgroundColor?: string;
  showOnSupplyChain?: boolean;
  level: number;
  sequence: number;
  isEnabled: boolean;
  children?: SkuCategoryTreeItem[];
};

export type SkuCategoryPageItem = SkuCategoryTreeItem & {
  parentName?: string;
  createdAt?: string;
};

export type SkuCategoryPageQuery = {
  keyword?: string;
  categoryType?: SkuCategoryType;
  parentCode?: string;
  level?: number;
  pageNum: number;
  pageSize: number;
};

export type SkuCategoryCreatePayload = {
  parentCode?: string;
  categoryType: SkuCategoryType;
  name: string;
  displayTitle?: string;
  displayDescription?: string;
  relatedCategoryText?: string;
  backgroundImageUrl?: string;
  backgroundColor?: string;
  showOnSupplyChain?: boolean;
  level: number;
  sequence?: number;
};

export type SkuCategoryUpdatePayload = {
  id: string | number;
  parentCode?: string;
  name: string;
  displayTitle?: string;
  displayDescription?: string;
  relatedCategoryText?: string;
  backgroundImageUrl?: string;
  backgroundColor?: string;
  showOnSupplyChain?: boolean;
  sequence?: number;
  isEnabled?: boolean;
};

export const GetSkuCategoryOptions = (categoryType: SkuCategoryType = SKU_CATEGORY_TYPE.JD_ECO) =>
  Client.get<SkuCategoryTreeItem[]>({
    url: apiPrefix + '/sc/sku/category/options',
    data: { categoryType },
  });

export const GetWebSkuCategoryOptions = (categoryType: SkuCategoryType = SKU_CATEGORY_TYPE.JD_ECO) =>
  Client.get<SkuCategoryTreeItem[]>({
    url: apiPrefix + '/web/sc/sku/category/options',
    data: { categoryType },
  });

export const GetAdminSkuCategoryTree = (categoryType: SkuCategoryType = SKU_CATEGORY_TYPE.SAMPLE) =>
  Client.get<SkuCategoryTreeItem[]>({
    url: apiPrefix + '/sc/admin/sku/category/tree',
    data: { categoryType },
  });

export const GetAdminSkuCategoryPage = (data: SkuCategoryPageQuery) =>
  Client.get<{ records: SkuCategoryPageItem[]; total: number; current: number; size: number }>({
    url: apiPrefix + '/sc/admin/sku/category/page',
    data,
  });

export const ExportAdminSkuCategory = (categoryType: SkuCategoryType = SKU_CATEGORY_TYPE.SAMPLE) => {
  const params = new URLSearchParams();
  params.append('categoryType', categoryType);
  const token = AccountModule.token || Cache.getToken('user');
  return downloadByAuthUrl(`/portal/sc/admin/sku/category/export?${params.toString()}`, token || undefined, 'sku-category-export.xls');
};

export const CreateAdminSkuCategory = (data: SkuCategoryCreatePayload) =>
  Client.post<void>({
    url: apiPrefix + '/sc/admin/sku/category/create',
    data,
  });

export const UpdateAdminSkuCategory = (data: SkuCategoryUpdatePayload) =>
  Client.put<void>({
    url: apiPrefix + '/sc/admin/sku/category/update',
    data,
  });

export const DeleteAdminSkuCategory = (data: { id: string | number }) =>
  Client.delete<void>({
    url: apiPrefix + '/sc/admin/sku/category/delete',
    data,
  });
